$(document).ready(function () {

    if ($('#rat-form').length > 0) {
        
        $('#rat-form').submit(function (e) {

            if ($('.g-recaptcha-response').val().length > 0) {
                return true;
            } else {
                $('.gr-error-message').addClass('gr-error-message--error');
            }
            return false;
        });

        var url = window.location.href;

        if (url.includes('submitted')) {
            $(".salesforce form").fadeOut();
            $(".success-message").fadeIn();
        }
    }
});